'use client'

import * as Dialog from 'primitives/dialog'
import { CloseIcon } from 'primitives/icons/close'
import { Button } from '@repo/design-system-cf/components/button'
import { Z_INDEX_MODALS } from 'constants/modals'
import { useConfirmationModal } from './confirmation-modal-provider'
import * as React from 'react'
import { useBreakpoint } from '@repo/web-ui/hooks/use-breakpoints'
import { tw } from 'utils/classnames'

export function ConfirmationModal() {
  const { isOpen, closeModal, title, message, confirmText, cancelText, isLoading, onConfirm } =
    useConfirmationModal()

  const handleConfirm = () => {
    onConfirm?.()
  }
  const { breakpoint } = useBreakpoint()

  const isMobile = ['xs', 'sm'].includes(breakpoint ?? '')

  return (
    <Dialog.Root open={isOpen} onOpenChange={open => !open && closeModal()}>
      <React.Suspense fallback={null}>
        <Dialog.Portal>
          <Dialog.Body
            placement={isMobile ? 'bottom' : 'middle'}
            className={tw(
              `font-poppins xl:items-center transition-transform duration-300 ease-in-out`,
              isOpen && isMobile ? 'translate-y-0' : 'translate-y-full',
            )}
            overlayZIndex={Z_INDEX_MODALS.authentication.react - 1}
            zIndex={Z_INDEX_MODALS.authentication.react}
            dismissable={!isLoading}
          >
            <div className="w-full md:max-w-xl border rounded-t-[12px] border-[#1313151F] bg-cf-white md:rounded-[12px] p-5 md:p-8 relative shadow-md">
              {!isLoading ? (
                <button className="absolute top-3 right-3" onClick={closeModal} type="button">
                  <CloseIcon className="text-cf-grey-600" />
                </button>
              ) : null}

              <h2 className="text-20  text-cf-grey-1000 font-bold mb-3">{title}</h2>
              <p className="text-6 text-cf-grey-800 mb-6">{message}</p>

              <div className="flex justify-center md:justify-end gap-1 md:gap-3">
                <Button
                  variant="ghost"
                  className="w-full md:w-auto"
                  onClick={closeModal}
                  disabled={isLoading}
                  type="button"
                >
                  {cancelText}
                </Button>
                <Button
                  onClick={handleConfirm}
                  className="w-full md:w-auto"
                  disabled={isLoading}
                  type="button"
                >
                  {isLoading ? 'Loading...' : confirmText}
                </Button>
              </div>
            </div>
          </Dialog.Body>
        </Dialog.Portal>
      </React.Suspense>
    </Dialog.Root>
  )
}
